module.exports = __webpack_public_path__ + "static/media/TimeTransper.75fc2069.svg";